import { getCmsData, renderWithErrorBoundary } from "./functions";
import HeroBanner from "./components/hero-banner/HeroBanner";

export default function initHomepage() {
  const heroTarget = document.querySelector("#homepage #hero-banner-react");
  if (heroTarget) {
    const heroData = getCmsData("heroBannerDataCMS");
    if (heroData) {
      renderWithErrorBoundary(HeroBanner, heroTarget, { HeroBanner: heroData });
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                       Dynamically imported components                      */
  /* -------------------------------------------------------------------------- */

  /**
   * The below components are dynamically imported as Squiz Matrix authors have
   * the ability to enable or disable the visibility of said components.
   *
   * The `webpackMode` for each component is set to `eager`. Because this
   * homepage module is dynamically imported using `webpackChunkName`, each
   * eagerly-loaded sub-component below will be bundled into the same chunk.
   */

  /* ---------------------------------- News ---------------------------------- */

  const newsTarget = document.querySelector("#homepage #news-events-react");
  if (newsTarget) {
    import(
      /* webpackMode: "eager" */
      "./components/homepage/news/News"
    ).then(module => renderWithErrorBoundary(module.default, newsTarget));
  }

  /* --------------------------------- Events --------------------------------- */

  const eventsTarget = document.querySelector("#homepage #events-react");
  if (eventsTarget) {
    import(
      /* webpackMode: "eager" */
      "./components/homepage/events/Events"
    ).then(module => renderWithErrorBoundary(module.default, eventsTarget));
  }

  /* ------------------------------- Top Topics ------------------------------- */

  const topTopicsTarget = document.querySelector("#homepage #top-topics-react");
  if (topTopicsTarget) {
    import(
      /* webpackMode: "eager" */
      "./components/homepage/top-topics/TopTopics"
    ).then(module => renderWithErrorBoundary(module.default, topTopicsTarget));
  }

  /* ---------------------------------- About --------------------------------- */

  const aboutTarget = document.querySelector("#homepage #about-react");
  if (aboutTarget) {
    import(
      /* webpackMode: "eager" */
      "./components/homepage/about/About"
    ).then(module => renderWithErrorBoundary(module.default, aboutTarget));
  }

  /* -------------------------------- Subscribe ------------------------------- */

  const subscribeTarget = document.querySelector("#homepage #subscribe-react");
  if (subscribeTarget) {
    import(
      /* webpackMode: "eager" */
      "./components/homepage/subscribe/Subscribe"
    ).then(module => renderWithErrorBoundary(module.default, subscribeTarget));
  }
}
